var map = {
	"./bug.svg": 37560,
	"./dark.svg": 78521,
	"./dragon.svg": 40749,
	"./electric.svg": 27390,
	"./fairy.svg": 79788,
	"./fighting.svg": 96733,
	"./fire.svg": 23051,
	"./flying.svg": 6021,
	"./ghost.svg": 28367,
	"./grass.svg": 20713,
	"./ground.svg": 73808,
	"./ice.svg": 8215,
	"./normal.svg": 35646,
	"./poison.svg": 14960,
	"./psychic.svg": 63462,
	"./rock.svg": 40545,
	"./steel.svg": 62560,
	"./water.svg": 63144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14291;